import { Outlet } from 'react-router-dom';
import { ClientOnly } from 'vite-react-ssg';
import { Nav } from '../components/organisms/Nav/Nav';
import { Footer } from '../components/organisms/Footer/Footer';
import { ChatbotFab } from '../features/Chatbot/ChatbotFab';

// 공개 영역 레이아웃 — 라우트 객체(routes.jsx)의 pathless layout route.
// Nav/Footer 는 정적 프리렌더(SEO·즉시 노출). 페이지 본문은 <Outlet/> 로 주입.
//
// ChatbotFab 은 ClientOnly 로 감싼다:
//   - useEmergencyMode 의 초기 상태가 new Date() 기반(빌드 시각 vs 로드 시각이
//     다르면 aria-label 이 어긋나 하이드레이션 불일치 발생).
//   - 소켓/포털 등 브라우저 전용이고 SEO 가치가 없어 정적 HTML 에서 빼도 무방.
// fallback=null → 정적 HTML 에는 FAB 미포함, 하이드레이트 후 클라이언트에서 마운트.
export function PublicShell() {
  return (
    <>
      <Nav />
      <Outlet />
      <Footer />
      <ClientOnly fallback={null}>{() => <ChatbotFab />}</ClientOnly>
    </>
  );
}
